module.exports = __webpack_public_path__ + "static/media/logo.72980eac.png";